import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-sale-report',
  imports: [TranslatePipe],
  templateUrl: './sale-report.html',
  styleUrl: './sale-report.css',
})
export class SaleReport {

}
